<template>
  <div id="video-lightbox" @click="e => onOutsideClick(e)">
    <v-overlay
      id="video-overlay"
      :value="show"
      z-index="9999"
      color="#000000"
      opacity="0.8"
    >
      <div class="vimeo-player-container">
        <div class="vimeo-player-header">
          <div class="caption">
            <p>
              {{ videoTitle }}
            </p>
          </div>
          <div class="video-player-close" @click="() => closeVideoLightbox()">
            <BaseIcon icon="close" hover size="20px" />
          </div>
        </div>
        <vimeo-player
          class="vimeo-player"
          :options="videoPlayerOptions"
          :video-url="videoUrl"
          :video-id="1"
        />
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";

export default {
  name: "VideoLightbox",
  components: { "vimeo-player": vueVimeoPlayer },
  data: function() {
    return {
      show: false,
      videoTitle: "",
      videoUrl: null,
      videoPlayerOptions: {
        autoplay: true,
        responsive: true
      }
    };
  },
  mounted() {
    this.$root.$on("openVideoLightbox", video => {
      this.videoUrl = video.video_url;
      this.videoTitle = video.title;
      this.show = true;
    });

    this.$on("hook:beforeDestroy", function() {
      this.$root.$off("openVideoLightbox");
    });
  },
  methods: {
    onOutsideClick(e) {
      //Check for click outside overlay content
      if (e.target.className == "v-overlay__scrim") {
        this.closeVideoLightbox();
      }
    },
    closeVideoLightbox() {
      this.show = false;
      this.$root.$emit("closeVideoLightbox");
    }
  }
};
</script>

<style lang="scss">
#video-lightbox {
  .v-overlay {
    align-items: flex-start;

    &__content {
      top: 5%;
      max-height: 75vh;
    }
  }

  .vimeo-player-container {
    margin-top: 40px;
    min-width: 50vw;

    iframe {
      height: 75vh !important;
      width: 30vw;
    }
  }
  .vimeo-player {
    &-header {
      text-align: center;
      height: 42px;
      width: 100%;

      .caption {
        display: inline-block;
      }

      .video-player-close {
        display: inline-block;
        float: right;
        width: 20px;
      }
    }
  }
}
</style>
